<!--
 * @Author: liuwei
 * @Date: 2020-12-02 10:09:53
 * @LastEditTime: 2020-12-05 14:17:41
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \yq-act-web\src\views\hlb-purchase-act\rules.vue
-->
<template>
  <div class="rules">
    <!-- <img :src="imgHost + 'rule_bg.jpg?v=2'" alt=""> -->
    <!-- <div class="logo">
      <img
        :src="imgHost + 'logo.png'"
      />
    </div> -->
    <div class="rules-box">
      <div class="r-body">
        <div class="r-title"></div>
        1、进入游戏，点击屏幕操控锦鲤跃动，每成功通过一个龙门即可得一分。在游戏时间内，达到10分即可获得一次大转盘抽奖机会，盘盘有好礼！
        <br />2、每位用户初始拥有2次游戏机会，每传递一次活动给好友还可额外获得一次游戏机会，快来看看你和你的朋友谁才是真正游戏王！
        <br />3、活动期间，传播活动给好友，更可获得额外「金」喜，等你来发现！找好友帮您点击活动链接参与游戏，即可与您组成战队，冲击战队排行！还可获得以下惊喜大奖！
        <br />4、排行榜前三奖品每个战队仅限一份。
        <br />排行榜第一名：iphone12
        <br />排行榜第二名：纪梵希散粉
        <br />排行榜第三名：TOM FORD唇膏
        <br />活动时间：2021年6月8日9:00-2021年6月15日23:59
        <br />领奖时间：2021年6月16日9:00-2021年6月30日18:00
        <br />领奖地址：太仓市城厢镇弇山西路116号阳光城文澜府营销中心
        <br />
        <div class="b-bottom">
          <!-- <span>领奖地址</span>
          <div class="table">
            <div class="th">
              <div class="td">项目名称</div>
              <div class="td">领奖地址</div>
            </div>
            <div class="tr" v-for="(item, index) in addList" :key="index">
              <div class="td">{{item.projectName}}</div>
              <div class="td">{{item.addressName}}</div>
            </div>
          </div> -->
          
        </div>
      </div>
      <!-- <div class="js">
        本次活动由慈溪益坤置业有限公司在法律法规范围内保留最终解释权
      </div> -->
    </div>
    <BaseBtnHome></BaseBtnHome>
  </div>
</template>

<script>
// import Vue from "vue/dist/vue.js";
export default {
  name: "",
  components: {},
  data() {
    return {
      addList: [
        {
          projectName: '修文山湖海·上城',
          addressName: '贵阳白修线旁，玩意窝公园内'
        },
        {
          projectName: '遵义山湖海·瑞府',
          addressName: '遵义新蒲天鹅湖新蒲汇旁'
        },
        {
          projectName: '永兴山湖海·上城',
          addressName: '永兴县西水路碧水小学旁（鸡公岭生态公园对面）'
        },
        {
          projectName: '安乡山湖海·上城',
          addressName: '常德市安乡县子龙路与纯银路交汇处'
        },
        {
          projectName: '汉寿山湖海·上城',
          addressName: '汉寿县龙阳镇汉寿大道东侧（人民医院往南300米）'
        },
        {
          projectName: '宜章山湖海·上城',
          addressName: '宜章大道山湖海上城（百通汽车站往东800米）'
        },
        {
          projectName: '汨罗山湖海·上城',
          addressName: '汨罗市楚天路正则学校西门对面'
        },
        {
          projectName: '赤壁山湖海·悦府',
          addressName: '蒲圻大道与北山大道交汇处（赤壁北站以东）'
        }
      ]
    };
  },
  created() {},
  computed: {},
  watch: {},
  mounted() {
    // console.log(`当前城市名称--->${this.$root.curLocation.location}-----当前infoId--->${this.$root.curLocation.infoId}`)
    // this.$config.infoId = this.$root.curLocation.infoId; //在这个页面中infoId写死113
    // Vue.prototype.$infoId = this.$root.curLocation.infoId;
    // this.$httpdf
    //   .get(this.$apidf.xc_voice_purchase.getProjectsAddress, { infoId: this.$config.infoId }, {
    //     res: "data",
    //     infoId: this.$infoId || 0
    //   })
    //   .then((data) => {
    //     if (data.code == 0) {
    //       this.addList = data.data;
    //     }
    //   });
  },
  methods: {},
};
</script>

<style lang='scss' scoped>
.rules {
  width: 100%;
  min-height: 100vh;
  background: #BEDDEA url( $imgHost + 'rule_bg.jpg?t=8') 0 0 / 100% no-repeat;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
  .rules-box {
    padding: 54px 15px 0;
    .r-body {
      background: #6EAFD9;
      border-radius: 15px;
      padding: 36px 20px 10px;
      box-sizing: border-box;
    }
  }
}

.logo {
  width: $logoWidth;
  margin-top: 20px;
}
.r-title {
  width: 133px;
  height: 30px;
  background: url( $imgHost + 'rule_title.png?v=1') 0 0 / 100% no-repeat;
  position: absolute;
  left: 50%;
  top: -15px;
  transform: translateX(-50%);
}

.r-body {
  margin-top: 15px;
  box-sizing: border-box;
  width: 100%;
  height: auto;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 28px;
  letter-spacing: 1px;
  position: relative;
  z-index: 1;
  text-align: justify;
  text-justify: inter-ideograph;
  span {
    font-weight: bold
  }
  .b-bottom {
    margin-top: 20px;
    width: 100%;
    >span {
      display: block;
      text-align: center;
    }
    
    .table {
      border: 1px solid #fff;
      text-align: center;
      .th {
        display: flex;
        align-items: center;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FEFEFE;
        line-height: 24px;
      }
      .tr {
        display: flex;
        align-items: center;
        font-size: 10px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #FEFEFE;
        line-height: 15px;
        border-top: 1px solid #fff;
      }
      .td {
        flex: 3;
        padding: 10px 0;
        &:nth-child(2) {
          flex: 6;
          border-left: 1px solid #fff;
          border-right: 1px solid #fff;
        }
        &:nth-child(3) {
          flex: 4;
        }
      }
    }
  }
}
.js {
  width: 100%;
  height: 10px;
  font-size: 11px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 12px;
  color: #333;
  text-align: center;
  margin-top: 15px;
}
</style>
